export enum OnboardingRequestKeys {
    personalInformation = 'personalInformation',
    clientContract = 'clientContract',
    workContract = 'workContract',
    workPermit = 'workPermit',
    bankAccount = 'bankAccount',
    childAllowances = 'childAllowances',
    ssnInformation = 'ssnInformation',
    additionalInformation = 'additionalInformation',
    taxAtSource = 'taxAtSource',
    dataPayslip = 'dataPayslip',
}

export const TabKeyByPath = {
    '/personal-information': 'personalInformation',
    '/bank-account': 'bankAccount',
    '/work-contract': 'workContract',
    '/work-permit-report': 'workPermit',
};
